import { Link } from 'react-router-dom';

interface ArticleCardProps {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  author: string;
  date: string;
  image: string;
  summary: string;
  views: number;
  tags: string[];
}

export default function ArticleCard({
  id,
  title,
  category,
  categorySlug,
  author,
  date,
  image,
  summary,
  views,
  tags,
}: ArticleCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="flex flex-col sm:flex-row gap-4 p-4 rounded-lg bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer group"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="w-full sm:w-48 flex-shrink-0">
        <div className="relative overflow-hidden rounded-lg aspect-video sm:aspect-[4/3] bg-background-200">
          <img
            src={image}
            alt={title}
            title={title}
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
          />
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-2 mb-1.5">
          <Link
            to={`/category/${categorySlug}`}
            className="text-xs px-2 py-0.5 bg-primary-100 text-primary-700 rounded-full font-medium whitespace-nowrap hover:bg-primary-200 transition-colors cursor-pointer"
            onClick={(e) => e.stopPropagation()}
          >
            {category}
          </Link>
          <span className="text-xs text-foreground-400">{date}</span>
        </div>
        <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1.5 font-heading">
          {title}
        </h3>
        <p className="text-sm text-foreground-600 line-clamp-2 mb-2 leading-relaxed">
          {summary}
        </p>
        <div className="flex items-center flex-wrap gap-2">
          {tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="text-xs px-2 py-0.5 bg-background-100 text-foreground-600 rounded whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
          <span className="text-xs text-foreground-400 ml-auto flex items-center gap-1 whitespace-nowrap">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-eye-line"></i>
            </div>
            {views > 10000 ? `${(views / 10000).toFixed(1)}万` : views}
          </span>
        </div>
      </div>
    </Link>
  );
}